<template>
  <div class="checklist-table-select">
    <v-checkbox
      hide-details
      readonly
      :model-value="selected"
      :ripple="false"
      data-locator="select-checkbox"
      color="darkblue-500"
      @click.stop="$emit('select')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ChecklistTableTaskSelect',
  props: {
    selected: {
      type: Boolean,
      required: true,  
    },
  },
  emits: ['select'],
})
</script>